import { isProviderLocation, usePermissions } from '@michelin/central-provider';

export const useCurrentLocationIsDealer = (): boolean | null => {
  const permissions = usePermissions();
  if (!permissions.location) return null;
  return isProviderLocation(permissions.location);
};

export const useCurrentLocationType = () => {
  const permissions = usePermissions();
  if (!permissions.location) return false;
  const isDealer = isProviderLocation(permissions.location);
  return isDealer ? 'dealer' : 'fleet';
};
